import { colors } from '@ui/colors'
import Icon from '@ui/elements/Icon'
import DetailRow from '@ui/elements/DetailRow'
import PriceInfo from '@/price/PriceInfo'

interface Props {
  title?: string
  index?: number
  discount?: number
  onPress?: () => void
}

export default function DiscountItem({
  title,
  discount,
  index,
  onPress,
}: Props) {
  return (
    <DetailRow
      success
      size="xs"
      first={index === 0}
      title={title}
      titleComponent={
        <Icon name="x" size={16} strokeWidth={3} color={colors.neutral[400]} />
      }
      icon="circle-check-filled"
      onPress={onPress}
    >
      {!!discount && <PriceInfo size="default" value={discount} />}
    </DetailRow>
  )
}
